/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateSpecialHourRequest
 */
export interface CreateSpecialHourRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateSpecialHourRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof CreateSpecialHourRequest
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateSpecialHourRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpecialHourRequest
     */
    endTime: string;
}

/**
 * Check if a given object implements the CreateSpecialHourRequest interface.
 */
export function instanceOfCreateSpecialHourRequest(value: object): value is CreateSpecialHourRequest {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function CreateSpecialHourRequestFromJSON(json: any): CreateSpecialHourRequest {
    return CreateSpecialHourRequestFromJSONTyped(json, false);
}

export function CreateSpecialHourRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSpecialHourRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'date': (new Date(json['date'])),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function CreateSpecialHourRequestToJSON(json: any): CreateSpecialHourRequest {
    return CreateSpecialHourRequestToJSONTyped(json, false);
}

export function CreateSpecialHourRequestToJSONTyped(value?: CreateSpecialHourRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'date': value['date'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

